











import { Component, Prop, Ref, Mixins } from "vue-property-decorator";
import { i18n } from "@/i18n";

import {
  WidgetMixin,
  EventMixin,
  FieldMixin,
  Event,
  Validator,
} from "./mixins";

import SignaturePad from "@/components/SignaturePad.vue";

@Component({
  components: {
    SignaturePad,
  },
})
export default class WSignaturePad extends Mixins(
  WidgetMixin,
  EventMixin,
  FieldMixin
) {
  @Ref()
  signaturePad!: SignaturePad;

  @Prop({ type: String, default: "" })
  label!: string;

  get computedLabel() {
    return i18n.t(this.label);
  }

  reset() {
    this.signaturePad.clear();
    this.fieldValue = undefined;
    this.state = null;
  }

  @Validator("required")
  requiredValidator(value: any) {
    return !!value;
  }
}
